import React from 'react'
import '../../styles/Expertise/ExpertiseEnergy.css'
import { Fade } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import expertiseEnergySection2 from '../../assets/expertise/expertise-energy-section2.jpg'
import expertiseEnergySection3 from '../../assets/expertise/expertise-energy-section3.jpg'
import expertiseEnergySection4 from '../../assets/expertise/expertise-energy-section4.jpg'
import AccordionText from '../Utils/AccordionText'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function ExpertiseEnergy() {

    const section3AccordionData = [
        {
            title: "Réduction des factures énergétiques",
            text: "L’audit identifie les postes de consommation énergétique excessives et propose des solutions concrètes pour les réduire."
        }, {
            title: "Amélioration du confort",
            text: "En ciblant les améliorations à apporter, l’audit contribue à augmenter le confort thermique des occupants tout au long de l’année."
        }, {
            title: "Valorisation de votre bien",
            text: "Un bâtiment performant énergétiquement est plus attractif sur le marché immobilier, que ce soit pour la vente ou la location."
        }, {
            title: "Contribution à l'effort écologique",
            text: "Réduire la consommation d’énergie de votre bien participe à l’effort collectif de réduction des émissions de gaz à effet de serre."
        }
    ]

    const section4Accordion1Data = [
        {
            title: "Diagnostic initial",
            text: "Nos experts analysent vos factures énergétiques et réalisent un premier état des lieux de votre propriété."
        }, {
            title: "Visite sur site",
            text: "Nous procédons à une inspection détaillée de votre bâtiment pour évaluer les performances énergétiques de l’enveloppe et des systèmes."
        }, {
            title: "Analyse et modélisation",
            text: "Grâce à des outils de modélisation énergétique avancés, nous identifions les scénarios d’amélioration les plus efficaces."
        }, {
            title: "Rapport et recommandations",
            text: "Vous recevez un rapport complet incluant une analyse des coûts et bénéfices des différentes mesures d’amélioration proposées."
        }, {
            title: "Accompagnement",
            text: "E5M Diagnostic vous accompagne dans la mise en œuvre des recommandations pour maximiser votre investissement énergétique."
        },
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Audit énergétique consultatif - E5M Diagnostics" />
                <meta name="description" content="Audit énergétique consultatif sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Audit énergétique consultatif - E5M Diagnostics" />
                <meta property="og:description" content="Audit énergétique consultatif sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/audit-énergétique-consultatif" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/audit-énergétique-consultatif" />
            </Helmet>

            <BrowserView>
                <div id='expertiseEnergy'>
                    <div id='header'>
                        <div id='expertiseEnergyHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Audit Énergétique Consultatif</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='expertiseEnergySection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseEnergySection1Left'>
                                    <div className='sectionTitle'>Optimisez votre patrimoine avec l'audit énergétique d'E5M Diagnostics</div>
                                    <div className='sectionText'>
                                        Dans un contexte de prise de conscience écologique et d’augmentation des coûts de l’énergie, l’efficacité énergétique est devenue une priorité pour les propriétaires de biens immobiliers. L’audit énergétique consultatif proposé par
                                        E5M Diagnostics constitue un levier essentiel pour transformer votre bâtiment en un espace plus confortable, économique et respectueux de l’environnement.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='expertiseEnergySection1Right'>
                                    <div className='sectionTitle'>Pourquoi et comment réaliser un audit énergétique ?</div>
                                    <div className='sectionText'>
                                        Pour identifier précisément les faiblesses énergétiques de votre bâtiment et définir les mesures correctives les plus louables. Cela vous permet de diminuer vos factures énergétiques et d’améliorer le confort intérieur, tout en contribuant à la
                                        protection de l’environnement.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseEnergySection2'>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='expertiseEnergySection2Left'>
                                    <h1 className='sectionTitle'>Pourquoi et comment réaliser un audit énergétique</h1>
                                    <div className='sectionText'>
                                        Pour identifier précisément les faiblesses énergétiques de votre bâtiment et définir les mesures correctives les plus louables. Cela vous permet de diminuer vos factures énergétiques et d’améliorer le confort intérieur, tout en contribuant à la
                                        protection de l’environnement.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='expertiseEnergySection2Right'>
                                    <img src={expertiseEnergySection2} id='expertiseEnergySection2Image' alt='expertise-energy-section2' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseEnergySection3'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseEnergySection3Left'>
                                    <img src={expertiseEnergySection3} id='expertiseEnergySection3Image' alt='expertise-energy-section3' />
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='expertiseEnergySection3Right'>
                                    <h1 className='sectionTitle'>Pourquoi réaliser un audit énergétique ?</h1>
                                    <div id='expertiseEnergySection3Accordion' className='sectionAccordionDark'>
                                        <Accordion>
                                            {section3AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseEnergySection4'>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='expertiseEnergySection4Left'>
                                    <h1 className='sectionTitle'>Les étapes clés de l'audit énergétique avec E5M Diagnostics</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section4Accordion1Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='expertiseEnergySection4Right'>
                                    <img src={expertiseEnergySection4} id='expertiseEnergySection4Image' alt='expertise-energy-section4' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='expertiseEnergySection5'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitle'>À quel prix ?</h1>
                            <div className='sectionText'>
                                Le coût d’un audit énergétique varie en fonction de la taille et de la complexité du bâtiment. E5M Diagnostics offre des appareils personnalisés pour garantir une prestation adaptée à vos besoins et à votre budget.
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseEnergySection6'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitle'>Particulier / Entreprise et syndic</h1>
                            <div className='sectionText'>
                                Que vous soyez un particulier, une entreprise ou un syndic de copropriété, E5M Diagnostics propose des solutions d’audit énergétique adaptées à chaque type de clientèle. Nos services sur mesure vous aideront à optimiser votre
                                patrimoine, quelle que soit sa nature ou sa taille.
                            </div>
                            <div className='sectionText'>
                                En sélectionnant E5M Diagnostics pour votre audit énergétique, vous optez pour une expertise reconnue et des conseils sur mesure pour faire de votre patrimoine un modèle d’efficacité énergétique.
                            </div>
                        </Fade>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id='expertiseEnergy'>
                    <div id='header'>
                        <div id='expertiseEnergyHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Audit Énergétique Consultatif</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='expertiseEnergySection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <div className='sectionTitleMobile'>Optimisez votre patrimoine avec l'audit énergétique d'E5M Diagnostics</div>
                            <div className='sectionTextMobile'>
                                Dans un contexte de prise de conscience écologique et d'augmentation des coûts de l'énergie, l'efficacité énergétique est devenue une priorité pour les propriétaires de biens immobiliers. L'audit énergétique consultatif proposé par
                                E5M Diagnostics constitue un levier essentiel pour transformer votre bâtiment en un espace plus confortable, économique et respectueux de l'environnement.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <div className='sectionTitleMobile'>Pourquoi et comment réaliser un audit énergétique ?</div>
                            <div className='sectionTextMobile'>
                                Pour identifier précisément les faiblesses énergétiques de votre bâtiment et définir les mesures correctives les plus louables. Cela vous permet de diminuer vos factures énergétiques et d'améliorer le confort intérieur, tout en contribuant à la
                                protection de l'environnement.
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseEnergySection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Pourquoi et comment réaliser un audit énergétique</h1>
                            <div className='sectionTextMobile'>
                                Pour identifier précisément les faiblesses énergétiques de votre bâtiment et définir les mesures correctives les plus louables. Cela vous permet de diminuer vos factures énergétiques et d'améliorer le confort intérieur, tout en contribuant à la
                                protection de l'environnement.
                            </div>
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <img src={expertiseEnergySection2} id='expertiseEnergySection2ImageMobile' alt='expertise-energy-section2' />
                        </Fade>
                    </div>
                    <div id='expertiseEnergySection3Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <img src={expertiseEnergySection3} id='expertiseEnergySection3ImageMobile' alt='expertise-energy-section3' />
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Pourquoi réaliser un audit énergétique ?</h1>
                            <div id='expertiseEnergySection3Accordion' className='sectionAccordionDark sectionAccordionDarkMobile'>
                                <Accordion>
                                    {section3AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseEnergySection4Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Les étapes clés de l'audit énergétique avec E5M Diagnostics</h1>
                            <div className='sectionAccordion sectionAccordionMobile'>
                                <Accordion>
                                    {section4Accordion1Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <img src={expertiseEnergySection4} id='expertiseEnergySection4ImageMobile' alt='expertise-energy-section4' />
                        </Fade>
                    </div>
                    <div id='expertiseEnergySection5Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>À quel prix ?</h1>
                            <div className='sectionTextMobile'>
                                Le coût d'un audit énergétique varie en fonction de la taille et de la complexité du bâtiment. E5M Diagnostics offre des appareils personnalisés pour garantir une prestation adaptée à vos besoins et à votre budget.
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseEnergySection6Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Particulier / Entreprise et syndic</h1>
                            <div className='sectionTextMobile'>
                                Que vous soyez un particulier, une entreprise ou un syndic de copropriété, E5M Diagnostics propose des solutions d'audit énergétique adaptées à chaque type de clientèle. Nos services sur mesure vous aideront à optimiser votre
                                patrimoine, quelle que soit sa nature ou sa taille.
                            </div>
                            <div className='sectionTextMobile'>
                                En sélectionnant E5M Diagnostics pour votre audit énergétique, vous optez pour une expertise reconnue et des conseils sur mesure pour faire de votre patrimoine un modèle d'efficacité énergétique.
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default ExpertiseEnergy